/**
 * 呼叫中心
 */

/**
 * 呼叫过程CODE
 * @param CORG 去电
 * @param CALLING 来电
 * @param CBEGIN 去电接通
 * @param CALLING_CBEGIN 来电接通
 * @param WAIT 呼叫等待
 * @param CEND 结束
 */
export enum CallingCode {
  CORG = 'CORG', // 去电
  CALLING = 'CALLING', // 来电
  CBEGIN = 'CBEGIN', // 去电接通
  CALLING_CBEGIN = 'CALLING_CBEGIN', // 来电接通
  WAIT = 'WAIT', // 呼叫等待
  CEND = 'CEND' // 结束
}

/**
 * SIP呼叫错误提示代码
 */
export const sipErrorCode = [
  {
    code: '"NO_ROUTE_DESTINATION"',
    msg: '404呼叫失败'
  },
  {
    code: '"NO_USER_RESPONSE"',
    msg: '408呼叫失败'
  },
  {
    code: '"INVALID_NUMBER_FORMAT"',
    msg: '484呼叫失败'
  },
  {
    code: '"NORMAL_UNSPECIFIED"',
    msg: '480呼叫失败'
  },
  {
    code: '"NORMAL_TEMPORARY_FAILURE"',
    msg: '503呼叫失败'
  },
  {
    code: '"SERVICE_UNAVAILABLE"',
    msg: '呼叫失败'
  },
  {
    code: '"SERVICE_NOT_IMPLEMENTED"',
    msg: '501呼叫失败'
  },
  {
    code: '"INCOMPATIBLE_DESTINATION"',
    msg: '488呼叫失败'
  }
]

/**
 * 轮呼任务状态
 */
export const turnCallTaskStatus = [
  { value: 1, label: '未开始' },
  { value: 2, label: '进行中' },
  { value: 3, label: '已暂停' },
  { value: 4, label: '逾期未完成' },
  { value: 5, label: '逾期已完成' },
  { value: 6, label: '已完成' }
]

// 群呼任务状态
export const groupCallStatus = [
  { value: 0, label: '未开始' },
  { value: 1, label: '已暂停' },
  { value: 2, label: '进行中' },
  { value: 3, label: '已结束' }
]

/**
 * 群呼坐席状态
 */
export enum seatStatusEnum {
  FREE = 0, // 空闲
  LEAVE = 1 // 离开
}
export const seatStatus = [
  {
    value: 0,
    label: '空闲',
    enum: 'FREE'
  },
  {
    value: 1,
    label: '离开',
    enum: 'LEAVE'
  }
]

/**
 * 呼叫中心状态
 * @param READY 已就绪
 * @param CALLING 通话中
 * @param CLEANUP 写跟进
 * @param STOP 已停止
 * @param EXPIRED 已欠费
 */
export enum callCenterStatusEnum {
  READY = 0, // 已就绪
  CALLING = 1, // 通话中
  CLEANUP = 2, // 写跟进
  STOP = 3, // 已停止
  EXPIRED = 4 // 已欠费floatMenuVisible
}

export const callCenterStatus = [
  {
    value: 0,
    label: '已就绪',
    enum: 'READY'
  },
  {
    value: 1,
    label: '通话中',
    enum: 'CALLING'
  },
  {
    value: 2,
    label: '写跟进',
    enum: 'CLEANUP'
  },
  {
    value: 3,
    label: '已停止',
    enum: 'STOP'
  },
  {
    value: 4,
    label: '已欠费',
    enum: 'EXPIRED'
  }
]

/**
 * 静音状态
 * @param mute 静音
 * @param unmute 非静音
 */
export enum mutedStatus {
  mute = 'mute', // 静音
  unmute = 'unmute' // 非静音
}

/**
 * 拨叫场景
 */
export enum dialingScenes {
  singleCall = 0, // 单呼
  quickCall = 1, // 快速呼叫
  turnCall = 2, // 轮呼
  turnCallApp = 3, // PC唤起APP轮呼
  groupCall = 4, // 群呼
  dokaCallIn = 5, // 多卡话机来电
  dokaRoundCallIn = 6, // 多卡话机轮呼过程中来电
  relateCustomer = 7 // 关联场景
}

/**
 * 关联场景
 */
export enum relateScenes {
  turnCall = 1, // 轮呼
  records = 2, // 通话记录
  numberCheck = 3, // 号码检测
  groupCall = 4 // 群呼
}

/**
 * 呼叫结果
 * @param connected // 已接通
 * @param unConnected // 未接通
 * @param failed // 呼叫异常失败
 */
export enum callResult {
  startCall = 0, // 发起呼叫中
  connected = 1, // 已接通
  unConnected = 2, // 未接通
  failed = 3 // 呼叫异常失败
}

/**
 * 呼叫方式
 * @param noset 未设置
 * @param daco 多卡话机
 * @param sip 软件电话
 */
export enum callType {
  noset = 0, // 未设置
  daco = 1, // 多卡话机
  sip = 2, // 软件电话
  app = 3 // 本机
}

/**
 * 呼叫方向
 * @param out 呼出
 * @param in  呼入
 */
export enum callDirection {
  out = 1,
  in = 2
}

// 1、SIM卡 2、SIP 3、SIM卡&SIP
export const lineTypeList = [
  { value: 1, label: 'SIM卡' },
  { value: 2, label: 'SIP' },
  { value: 3, label: 'SIM卡&SIP' }
]

// 是否强制校验黑名单
export const backlistCheck = [
  { value: 1, label: '是' },
  { value: 0, label: '否' }
]

// 通话状态-轮呼
export const roundCallStatusList = [
  {
    value: 1,
    label: '已接通'
  },
  {
    value: 2,
    label: '未接通'
  },
  {
    value: 3,
    label: '呼叫异常'
  },
  {
    value: 4,
    label: '黑名单用户'
  }
]
// 群呼详情-坐席组详情-通话状态
export const callGroupViewSeatStatusEnum = [
  { value: 1, label: '通话中' },
  { value: 2, label: '写跟进' }
]
// 群呼详情-坐席组详情-执行任务状态
export const callGroupSeatStatusEnum = [
  { value: 1, label: '离开' },
  { value: 0, label: '空闲' }
]
// 添加到伦湖待联系操作区枚举
export enum operateAreaEnum {
  customer = 10, // 普通客户
  enterpriseCustomer = 20, // 企业客户
  customerClue = 30, // 普通客户线索
  enterpriseClue = 40, // 企业客户线索
  contacted = 50, // 轮呼已联系
  customerNumberCheck = 60, // 普通号码检测列表
  enterpriseNumberCheck = 70, // 企业号码检测列表
  customerImport = 80, // 普通客户联系人导入号码检测
  enterpriseImport = 90, // 企业客户联系人导入号码检测
  uncontacted = 100 // 轮呼待联系
}

// 通话时间设置
export const callTimeSet = [
  { value: 2, label: '2秒' },
  { value: 3, label: '3秒' },
  { value: 4, label: '4秒' },
  { value: 5, label: '5秒' },
  { value: 6, label: '6秒' },
  { value: 7, label: '7秒' },
  { value: 8, label: '8秒' },
  { value: 9, label: '9秒' },
  { value: 10, label: '10秒' }
]

// 接听情况
export const answerStatus = [
  { value: 1, label: '已接听' },
  { value: 0, label: '未接听' }
]
export const nomalStatus = [
  { value: 1, label: '成功' },
  { value: 0, label: '失败' }
]
export const directionList = [
  {
    value: 1,
    label: '呼出'
  },
  {
    value: 2,
    label: '呼入'
  }
]

export const callModeList = [
  {
    value: 1,
    label: '工作机'
  },
  {
    value: 2,
    label: '外呼'
  }
]

// 通话状态-通话记录
export const callStatusList = [
  {
    value: 1,
    label: '已接通'
  },
  {
    value: 2,
    label: '未接通'
  }
]

// 群呼结果失败原因
export const cloudGroupCallFailedReason = [
  { value: 1, label: '黑名单用户' },
  { value: 2, label: '其他原因' }
]
// 分配情况
export const allocatedStatus = [
  { value: 1, label: '已分配' },
  { value: 0, label: '未分配' }
]
// 多卡话机发送消息
export const dacoMsg = {
  // link连接
  link: {
    cmd: 'LINK'
  },
  // 获取IMEI
  getIMEI: {
    cmd: 'READIMEI'
  },
  // 获取iccic
  getIccid: {
    cmd: 'getIccid'
  },
  // 拨打电话
  ATD: {
    cmd: 'ATD'
  },
  // 获取当前使用卡槽
  getSimIndex: {
    cmd: 'getSimIndex'
  },
  // 切卡
  changeSim: {
    cmd: 'changeSim'
  },
  // 挂断
  ATH: {
    cmd: 'ATH'
  }
}

// 号码检测
export const phoneCheckResult = [
  { value: 0, label: '空号' },
  { value: 1, label: '正常' },
  { value: 4, label: '非活跃号码' },
  { value: 5, label: '风险号码' },
  { value: 12, label: '无效号码' }
]
